import * as React from "react"
import { Helmet } from "react-helmet"

export default function Seo({ seo, page }) {


  return (
    <Helmet
      htmlAttributes={{
        lang: "en-us",
      }}
    >
      <meta charSet="utf-8" />

      <title>
        {seo.metaTitle} - {page.metaTitle ? page.metaTitle : page.title}
      </title>

      {seo.metaDesc && (
        <meta
          name="description"
          property="og:description"
          content={page.metaDescription ? page.metaDescription : seo.metaDesc}
        />
      )}
      <meta
        property="og:title"
        content={seo.metaTitle + " - " + page.metaTitle}
      />
      {seo.openGraphImage && (
        <meta property="og:image" content={seo.openGraphImage.asset.url} />
      )}
      <meta name="twitter:card" content={seo.shareDesc} />
      <meta
        name="twitter:title"
        content={seo.shareTitle + " - " + page.metaTitle}
      />
      {seo.shareDesc && (
        <meta name="twitter:description" content={seo.shareDesc} />
      )}
      {seo.openGraphImage && (
        <meta name="twitter:image" content={seo.openGraphImage.asset.url} />
      )}
    </Helmet>
  )
}
